(() => {
  function enhance(el) {
    if (el.dataset.chatReady === '1') return;
    const label = (el.dataset.label || el.textContent || 'Chat with us').trim();
    el.innerHTML = '';
    const a = document.createElement('a');
    a.href = '#';
    a.className = 'openChatWidget__link';
    a.textContent = label;
    el.appendChild(a);
    el.dataset.chatReady = '1';
  }

  function openChat() {
    if (window.GorgiasChat && typeof GorgiasChat.open === 'function') {
      GorgiasChat.open();
      return;
    }
    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      if (window.GorgiasChat && typeof GorgiasChat.open === 'function') {
        clearInterval(iv);
        GorgiasChat.open();
      } else if (tries > 40) {
        clearInterval(iv);
        console.warn('GorgiasChat not available yet.');
      }
    }, 250);
  }

  function init() {
    document.querySelectorAll('.openChatWidget').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('click', (e) => {
    const target = e.target.closest('.openChatWidget, .openChatWidget__link');
    if (!target) return;
    e.preventDefault();
    openChat();
  });

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('.openChatWidget')) enhance(n);
        n.querySelectorAll?.('.openChatWidget').forEach(enhance);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
